import { Component, OnDestroy, OnInit, Renderer2, Inject, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService, Credentials } from 'app/core/index';
import { finalize } from 'rxjs/operators';
import { RandomUsernameService } from 'app/core/random-username.service';
import { ModalService } from 'app/shared/modal.service';
import { TranslateService } from '@ngx-translate/core';
import { ErrorManagerService } from 'app/core/error-manager.service';
import { AlertService } from '@app/core/alert.service';
import { RecaptchaComponent } from 'ng-recaptcha';
import { environment } from '@env/environment';

@Component({
  selector: 'app-login-modal',
  templateUrl: './login-modal.template.html',
  styleUrls: ['./login-modal.template.scss'],
  animations: [],
})
export class LoginModalComponent implements OnInit, OnDestroy {
  loadingLogin: boolean = false;
  form: FormGroup;
  loading = false;
  errors: string = null;
  success: string = null;

  @ViewChild('captchaRef') captchaRef: RecaptchaComponent;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private auth: AuthenticationService,
    private activatedRoute: ActivatedRoute,
    private nick: RandomUsernameService,
    private translate: TranslateService,
    private modalService: ModalService,
    private errorManager: ErrorManagerService,
    private alertService: AlertService,
    protected renderer: Renderer2
  ) {}

  public ngOnInit() {
    this.createForm();
  }

  public ngOnDestroy() {}

  public login(captcha: string): void {
    this.form.get('g-recaptcha-response').patchValue(captcha);
    if (this.form.invalid) {
      this.validateAllFormFields(this.form);
      return;
    }
    this.auth
      .login(this.form.value)
      .pipe(
        finalize(() => {
          this.form.markAsPristine();
        })
      )
      .subscribe(
        (credentials: Credentials) => {
          this.loading = false;
          if (this.auth.userInfo) {
            if (this.activatedRoute.snapshot.queryParams.redirectTo) {
              this.router
                .navigate(['/', { outlets: { modal: null } }])
                .then(() => {
                  this.router.navigate([this.activatedRoute.snapshot.queryParams.redirectTo.split('(')[0]]);
                })
                .catch(() => {});
            } else {
              if (this.auth.userInfo.emailVerified === false) {
                this.router.navigate(['/', { outlets: { modal: 'signup-verify' } }]);
              } else if (this.auth.userInfo.phoneVerified === false) {
                if (environment.verifyPhone) {
                  this.router.navigate(['/', { outlets: { modal: 'phone-verify' } }]);
                } else {
                  this.router.navigate(['/', { outlets: { modal: null } }]);
                }
              } else {
                this.router.navigate(['/', { outlets: { modal: null } }]);
              }
            }
          }
        },
        (error: any) => {
          this.captchaRef.reset();
          this.loadingLogin = false;
          if (error.status < 500) {
            if (error.status === 429) {
              this.alertService.error({
                title: 'Error!',
                text: 'You got temporary block for too many attemps! Try to login after few minutes.',
                timer: 15,
              });
            } else {
              const er = error.json();

              this.alertService.error({
                title: 'Error!',
                text: er.message,
                timer: 5,
              });

              if (er.locked) {
                // this.locked = er.locked;
              }
              if (er.question) {
                // this.question = er.question;
                // this.loginForm.get('question').setValue(er.question);
              }
            }
          } else {
            this.alertService.error({
              title: 'Error!',
              text: "We can't connect to our servers. Try in few moments!",
            });
            /*
            this.translate.get(['alert.error', 'alert.unknown_error']).subscribe(trans => {
              this.modalService.openAlert({
                title: trans['alert.error'],
                text: trans['alert.unknown_error'],
              });
            });*/
          }
        }
      );
  }

  private createForm(): void {
    this.form = this.formBuilder.group({
      username: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
      'g-recaptcha-response': ['', Validators.required],
      question: null,
      answer: null,
    });
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  close() {
    this.router.navigate(['/', { outlets: { modal: null } }]);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/modals/login/login-modal.component.ts